import React, { useState } from "react";
import "./Mentors.css";
import AdminLayout from "../../../layouts/AdminLayout/AdminLayout";

const MentorsManagement = () => {
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [viewMode, setViewMode] = useState("table");

  const [mentors, setMentors] = useState([
    {
      id: 2,
      name: "Sara Ali",
      email: "sara.ali@email.com",
      role: "Mentor",
      status: "Active",
      eligibility: "Eligible",
      joinedDate: "2023-11-20",
      studentsTeaching: 45,
      rating: 4.8,
      avatar: "SA",
      phone: "+92 321 9876543",
      location: "Lahore, Pakistan",
    },
    {
      id: 5,
      name: "Usman Sheikh",
      email: "usman.sheikh@email.com",
      role: "Mentor",
      status: "Pending",
      eligibility: "Pending",
      joinedDate: "2023-09-12",
      studentsTeaching: 38,
      rating: 4.7,
      avatar: "US",
      phone: "+92 312 4445555",
      location: "Faisalabad, Pakistan",
    },
    {
      id: 7,
      name: "Ali Hassan",
      email: "ali.hassan@email.com",
      role: "Mentor",
      status: "Rejected",
      eligibility: "Rejected",
      joinedDate: "2024-02-10",
      studentsTeaching: 0,
      rating: 0,
      avatar: "AH",
      phone: "+92 301 1112222",
      location: "Peshawar, Pakistan",
    },
  ]);

  const stats = {
    total: mentors.length,
    eligible: mentors.filter((m) => m.eligibility === "Eligible").length,
    pending: mentors.filter((m) => m.eligibility === "Pending").length,
    rejected: mentors.filter((m) => m.eligibility === "Rejected").length,
  };

  const filteredMentors = mentors.filter((mentor) => {
    const matchesFilter =
      selectedFilter === "all" ||
      mentor.eligibility.toLowerCase() === selectedFilter ||
      mentor.status.toLowerCase() === selectedFilter;
    const matchesSearch =
      mentor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      mentor.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      String(mentor.id).includes(searchQuery);
    return matchesFilter && matchesSearch;
  });

  const handleMentorClick = (mentor) => setSelectedMentor(mentor);
  const closeModal = () => setSelectedMentor(null);

  const handleApprove = (e, mentorId) => {
    e.stopPropagation();
    setMentors(
      mentors.map((m) =>
        m.id === mentorId
          ? { ...m, eligibility: "Eligible", status: "Active" }
          : m,
      ),
    );
  };

  const handleReject = (e, mentorId) => {
    e.stopPropagation();
    setMentors(
      mentors.map((m) =>
        m.id === mentorId
          ? { ...m, eligibility: "Rejected", status: "Rejected" }
          : m,
      ),
    );
  };

  const handleToggleStatus = (e, mentorId) => {
    e.stopPropagation();
    setMentors(
      mentors.map((m) =>
        m.id === mentorId
          ? { ...m, status: m.status === "Active" ? "Inactive" : "Active" }
          : m,
      ),
    );
  };

  const exportToCSV = () => {
    const headers = [
      "ID",
      "Name",
      "Email",
      "Status",
      "Eligibility",
      "Students",
      "Rating",
      "Joined Date",
    ];
    const csvData = filteredMentors.map((m) => [
      m.id,
      m.name,
      m.email,
      m.status,
      m.eligibility,
      m.studentsTeaching,
      m.rating,
      m.joinedDate,
    ]);
    const csvContent = [
      headers.join(","),
      ...csvData.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.setAttribute("href", URL.createObjectURL(blob));
    link.setAttribute("download", `mentors_export_${Date.now()}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getEligibilityColor = (eligibility) => {
    const colors = {
      eligible: { bg: "#e8f5e9", color: "#388e3c" },
      pending: { bg: "#fff3e0", color: "#f57c00" },
      rejected: { bg: "#ffebee", color: "#d32f2f" },
    };
    return colors[eligibility?.toLowerCase()] || colors.pending;
  };

  return (
    <AdminLayout>
      <div className="ment-container">
        <div className="ment-header">
          <p className="ment-subtitle">
            Manage mentor applications, eligibility, and activity
          </p>
          <button className="ment-export-btn" onClick={exportToCSV}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
            Export CSV
          </button>
        </div>

        <div className="ment-stats-grid">
          <div className="ment-stat-card">
            <div className="ment-stat-icon ment-icon-total">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <line x1="23" y1="11" x2="17" y2="11"></line>
                <line x1="20" y1="8" x2="20" y2="14"></line>
              </svg>
            </div>
            <div className="ment-stat-info">
              <span className="ment-stat-num">{stats.total}</span>
              <span className="ment-stat-lbl">Total Mentors</span>
            </div>
          </div>

          <div className="ment-stat-card">
            <div className="ment-stat-icon ment-icon-eligible">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <div className="ment-stat-info">
              <span className="ment-stat-num">{stats.eligible}</span>
              <span className="ment-stat-lbl">Eligible</span>
            </div>
          </div>

          <div className="ment-stat-card">
            <div className="ment-stat-icon ment-icon-pending">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <div className="ment-stat-info">
              <span className="ment-stat-num">{stats.pending}</span>
              <span className="ment-stat-lbl">Pending</span>
            </div>
          </div>

          <div className="ment-stat-card">
            <div className="ment-stat-icon ment-icon-rejected">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
            <div className="ment-stat-info">
              <span className="ment-stat-num">{stats.rejected}</span>
              <span className="ment-stat-lbl">Rejected</span>
            </div>
          </div>
        </div>

        <div className="ment-controls">
          <div className="ment-filter-tabs">
            {["all", "eligible", "pending", "rejected"].map((f) => (
              <button
                key={f}
                className={`ment-filter-tab ${selectedFilter === f ? "ment-active" : ""}`}
                onClick={() => setSelectedFilter(f)}
              >
                {f === "all"
                  ? "All Mentors"
                  : f.charAt(0).toUpperCase() + f.slice(1)}
              </button>
            ))}
          </div>

          <div className="ment-control-right">
            <div className="ment-search-box">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              <input
                type="text"
                placeholder="Search by name, email, or ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="ment-view-toggle">
              <button
                className={`ment-view-btn ${viewMode === "table" ? "ment-active" : ""}`}
                onClick={() => setViewMode("table")}
                title="Table View"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <line x1="8" y1="6" x2="21" y2="6"></line>
                  <line x1="8" y1="12" x2="21" y2="12"></line>
                  <line x1="8" y1="18" x2="21" y2="18"></line>
                  <line x1="3" y1="6" x2="3.01" y2="6"></line>
                  <line x1="3" y1="12" x2="3.01" y2="12"></line>
                  <line x1="3" y1="18" x2="3.01" y2="18"></line>
                </svg>
              </button>
              <button
                className={`ment-view-btn ${viewMode === "grid" ? "ment-active" : ""}`}
                onClick={() => setViewMode("grid")}
                title="Grid View"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="3" y="3" width="7" height="7"></rect>
                  <rect x="14" y="3" width="7" height="7"></rect>
                  <rect x="14" y="14" width="7" height="7"></rect>
                  <rect x="3" y="14" width="7" height="7"></rect>
                </svg>
              </button>
            </div>
          </div>
        </div>

        {viewMode === "table" && (
          <div className="ment-table-wrapper">
            <table className="ment-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Mentor</th>
                  <th>Status</th>
                  <th>Students</th>
                  <th>Rating</th>
                  <th>Eligibility</th>
                  <th>Joined</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredMentors.map((mentor) => (
                  <tr key={mentor.id} onClick={() => handleMentorClick(mentor)}>
                    <td>
                      <span className="ment-id-badge">{mentor.id}</span>
                    </td>
                    <td>
                      <div className="ment-cell">
                        <div className="ment-avatar">{mentor.avatar}</div>
                        <div className="ment-info">
                          <span className="ment-name">{mentor.name}</span>
                          <span className="ment-email">{mentor.email}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        className={`ment-status-badge ment-status-${mentor.status.toLowerCase()}`}
                      >
                        {mentor.status}
                      </span>
                    </td>
                    <td>
                      <span className="ment-student-count">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                          <circle cx="9" cy="7" r="4"></circle>
                        </svg>
                        {mentor.studentsTeaching} students
                      </span>
                    </td>
                    <td>
                      <span className="ment-rating">
                        {mentor.rating > 0 ? `⭐ ${mentor.rating}` : "—"}
                      </span>
                    </td>
                    <td>
                      {mentor.eligibility === "Pending" ? (
                        <div className="ment-eligibility-actions">
                          <button
                            className="ment-approve-btn"
                            onClick={(e) => handleApprove(e, mentor.id)}
                          >
                            Approve
                          </button>
                          <button
                            className="ment-reject-btn"
                            onClick={(e) => handleReject(e, mentor.id)}
                          >
                            Reject
                          </button>
                        </div>
                      ) : (
                        <span
                          className="ment-eligibility-badge"
                          style={{
                            backgroundColor: getEligibilityColor(
                              mentor.eligibility,
                            ).bg,
                            color: getEligibilityColor(mentor.eligibility)
                              .color,
                          }}
                        >
                          {mentor.eligibility}
                        </span>
                      )}
                    </td>
                    <td className="ment-joined-date">{mentor.joinedDate}</td>
                    <td>
                      <div className="ment-action-btns">
                        <button
                          className="ment-action-btn ment-action-view"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleMentorClick(mentor);
                          }}
                          title="View Details"
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                          </svg>
                        </button>
                        <button
                          className={`ment-action-btn ${mentor.status === "Active" ? "ment-action-deactivate" : "ment-action-activate"}`}
                          onClick={(e) => handleToggleStatus(e, mentor.id)}
                          title={
                            mentor.status === "Active"
                              ? "Deactivate"
                              : "Activate"
                          }
                        >
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filteredMentors.length === 0 && (
              <div className="ment-empty-state">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <line x1="23" y1="11" x2="17" y2="11"></line>
                  <line x1="20" y1="8" x2="20" y2="14"></line>
                </svg>
                <h3>No mentors found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {viewMode === "grid" && (
          <div className="ment-grid">
            {filteredMentors.map((mentor) => (
              <div
                key={mentor.id}
                className="ment-card"
                onClick={() => handleMentorClick(mentor)}
              >
                <div className="ment-card-top">
                  <span className="ment-id-badge">#{mentor.id}</span>
                  <span
                    className={`ment-status-indicator ment-status-indicator-${mentor.status.toLowerCase()}`}
                  ></span>
                </div>
                <div className="ment-card-avatar">{mentor.avatar}</div>
                <h3 className="ment-card-name">{mentor.name}</h3>
                <p className="ment-card-email">{mentor.email}</p>
                <span
                  className={`ment-status-badge ment-status-${mentor.status.toLowerCase()}`}
                >
                  {mentor.status}
                </span>
                <div className="ment-card-eligibility">
                  {mentor.eligibility === "Pending" ? (
                    <div className="ment-eligibility-actions">
                      <button
                        className="ment-approve-btn"
                        onClick={(e) => handleApprove(e, mentor.id)}
                      >
                        Approve
                      </button>
                      <button
                        className="ment-reject-btn"
                        onClick={(e) => handleReject(e, mentor.id)}
                      >
                        Reject
                      </button>
                    </div>
                  ) : (
                    <span
                      className="ment-eligibility-badge"
                      style={{
                        backgroundColor: getEligibilityColor(mentor.eligibility)
                          .bg,
                        color: getEligibilityColor(mentor.eligibility).color,
                      }}
                    >
                      {mentor.eligibility}
                    </span>
                  )}
                </div>
                <div className="ment-card-stats">
                  <div className="ment-card-stat">
                    <span className="ment-card-stat-lbl">Students</span>
                    <span className="ment-card-stat-val">
                      {mentor.studentsTeaching}
                    </span>
                  </div>
                  <div className="ment-card-stat">
                    <span className="ment-card-stat-lbl">Rating</span>
                    <span className="ment-card-stat-val">
                      {mentor.rating > 0 ? `⭐ ${mentor.rating}` : "—"}
                    </span>
                  </div>
                </div>
                <p className="ment-card-joined">Joined {mentor.joinedDate}</p>
              </div>
            ))}
            {filteredMentors.length === 0 && (
              <div className="ment-empty-state">
                <svg
                  width="56"
                  height="56"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                </svg>
                <h3>No mentors found</h3>
                <p>Try adjusting your filters or search query</p>
              </div>
            )}
          </div>
        )}

        {selectedMentor && (
          <div className="ment-modal-overlay" onClick={closeModal}>
            <div
              className="ment-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="ment-modal-header">
                <div className="ment-modal-user-header">
                  <div className="ment-modal-avatar">
                    {selectedMentor.avatar}
                  </div>
                  <div>
                    <div className="ment-modal-id">
                      Mentor ID: #{selectedMentor.id}
                    </div>
                    <h3>{selectedMentor.name}</h3>
                    <p>{selectedMentor.email}</p>
                  </div>
                </div>
                <button className="ment-close-btn" onClick={closeModal}>
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="ment-modal-body">
                <div className="ment-badges-row">
                  <span className="ment-role-badge">Mentor</span>
                  <span
                    className={`ment-status-badge ment-status-${selectedMentor.status.toLowerCase()}`}
                  >
                    {selectedMentor.status}
                  </span>
                  <span
                    className="ment-eligibility-badge"
                    style={{
                      backgroundColor: getEligibilityColor(
                        selectedMentor.eligibility,
                      ).bg,
                      color: getEligibilityColor(selectedMentor.eligibility)
                        .color,
                    }}
                  >
                    {selectedMentor.eligibility}
                  </span>
                </div>
                <div className="ment-details-grid">
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Email</span>
                    <span className="ment-detail-val">
                      {selectedMentor.email}
                    </span>
                  </div>
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Phone</span>
                    <span className="ment-detail-val">
                      {selectedMentor.phone}
                    </span>
                  </div>
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Location</span>
                    <span className="ment-detail-val">
                      {selectedMentor.location}
                    </span>
                  </div>
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Joined Date</span>
                    <span className="ment-detail-val">
                      {selectedMentor.joinedDate}
                    </span>
                  </div>
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Students Teaching</span>
                    <span className="ment-detail-val">
                      {selectedMentor.studentsTeaching}
                    </span>
                  </div>
                  <div className="ment-detail-item">
                    <span className="ment-detail-lbl">Rating</span>
                    <span className="ment-detail-val">
                      {selectedMentor.rating > 0
                        ? `⭐ ${selectedMentor.rating}`
                        : "Not rated yet"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="ment-modal-footer">
                <button className="ment-modal-btn ment-modal-secondary">
                  Send Message
                </button>
                <button className="ment-modal-btn ment-modal-secondary">
                  View Activity
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default MentorsManagement;
